<!--src/views/ChangePassword/ChangePassword.vue-->
<template>
  <div class="change-password-mask">
    <div class="change-password-container">
      <button
        class="close-btn"
        @click="handleClose"
      >
        ×
      </button>
      <h2>修改密码</h2>
      <form
        class="change-password-form"
        @submit="handleChangePassword"
      >
        <!-- 旧密码输入 -->
        <div class="form-group">
          <label for="oldPassword">旧密码</label>
          <input
            id="oldPassword"
            class="pwd-input"
            :type="isPasswordVisible ? 'text' : 'password'"
            name="oldPassword"
            required
            placeholder="请输入当前密码"
          >
          <span
            class="pwd-toggle"
            @click="togglePassword"
          >
            <text
              class="iconfont-showhide"
              :class="{'icon-yanjing_xianshi': isPasswordVisible, 'icon-yanjing_yincang_o': !isPasswordVisible}"
            />
          </span>
        </div>

        <!-- 新密码输入 -->
        <div class="form-group">
          <label for="newPassword">新密码</label>
          <input
            id="newPassword"
            type="password"
            name="newPassword"
            required
            placeholder="请输入6-16位新密码"
          >
        </div>

        <!-- 确认新密码 -->
        <div class="form-group">
          <label for="confirmPassword">确认新密码</label>
          <input
            id="confirmPassword"
            type="password"
            name="confirmPassword"
            required
            placeholder="请再次输入新密码"
          >
        </div>

        <!-- 提交按钮 -->
        <button
          type="submit"
          class="submit-btn"
        >
          确认修改
        </button>

        <!-- 返回个人中心链接 -->
        <div class="back-profile-link">
          <router-link
            to="/profile"
            class="link"
          >
            返回个人中心
          </router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>
import '@/assets/font/iconfont-showhide.css'
import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { changePassword } from '@/api/user'

const router = useRouter()
const isPasswordVisible = ref(false)

// 关闭页面（返回个人中心）
const handleClose = () => router.push('/profile')

const togglePassword = () => {
  isPasswordVisible.value = !isPasswordVisible.value
}

// 提交修改密码
const handleChangePassword = async (e) => {
  e.preventDefault()
  const form = e.target
  const oldPassword = form.oldPassword.value.trim()
  const newPassword = form.newPassword.value.trim()
  const confirmPassword = form.confirmPassword.value.trim()

  // 基础验证
  if (!oldPassword || !newPassword || !confirmPassword) {
    alert('请填写所有必填字段！')
    return
  }

  // 密码长度验证
  if (newPassword.length < 6 || newPassword.length > 16) {
    alert('新密码需为6-16位！')
    return
  }

  // 新旧密码一致性验证（禁止新密码和旧密码相同）
  if (newPassword === oldPassword) {
    alert('新密码不能与旧密码相同！')
    return
  }

  // 两次新密码一致性验证
  if (newPassword !== confirmPassword) {
    alert('两次输入的新密码不一致！')
    return
  }

  try {
    // 调用修改密码接口
    const res = await changePassword({ oldPassword, newPassword })
    alert(res.msg || '密码修改成功！')

    // 清除本地登录态，强制重新登录
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')

    // 跳转到登录页
    router.push('/login')
  } catch (error) {
    console.error('修改密码失败：', error)
    // 旧密码错误时的提示优化
    if (error.response?.data?.msg === '旧密码错误') {
      alert('旧密码错误，请重新输入！')
    }
  }
}
</script>

<style lang="scss">
.change-password-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 9999;
  background: #faf3fc;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}
</style>

<style scoped lang="scss">
.change-password-container {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 0 25px rgba(255, 100, 120, 0.1);
  width: 340px;
  position: relative;
  z-index: 10000;
}

h2 {
  text-align: center;
  color: #d92146;
  margin: 0 0 20px 0;
  font-size: 26px;
  font-weight: 600;
}

.close-btn {
  position: absolute;
  top: 15px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 22px;
  color: #ff99aa;
  cursor: pointer;
  transition: all 0.2s ease;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #d92146;
    background: rgba(217, 33, 70, 0.08);
  }
}

.pwd-toggle {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: #d92146;
  font-size: 26px;
  cursor: pointer;
  padding: 0;
  width: 30px;
  height: 100%;
  max-height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pwd-toggle::after {
  border: none;
}
.pwd-input {
  padding-right: 45px !important;
  box-sizing: border-box;
}
.iconfont-showhide {
  font-size: 20px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
}
.form-group .input-wrapper input, .login-form .input-wrapper input, .register-form .input-wrapper input, .change-password-form .input-wrapper input {
  padding-right: 45px !important;
}
.change-password-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-group {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;

  label {
    color: #666;
    font-size: 15px;
    font-weight: 500;
  }

  input {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid #ffd6dc;
    border-radius: 8px;
    box-sizing: border-box;
    font-size: 15px;
    transition: all 0.3s ease;
    background-color: #fff9fa;

    &::placeholder {
      color: #ffb3c0;
    }

    &:focus {
      outline: none;
      border-color: #ff6b8b;
      box-shadow: 0 0 0 3px rgba(255, 107, 139, 0.1);
      background-color: white;
    }
  }
}

.submit-btn {
  padding: 13px;
  background: linear-gradient(135deg, #ff4d6d 0%, #d92146 100%);
  border: none;
  border-radius: 8px;
  color: white;
  font-size: 17px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  margin-top: 10px;

  &:hover {
    opacity: 0.95;
    box-shadow: 0 4px 12px rgba(217, 33, 70, 0.2);
  }

  &:active {
    transform: scale(0.98);
  }
}

.back-profile-link {
  text-align: center;
  font-size: 14px;
  margin-top: 5px;

  .link {
    color: #d92146;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      color: #b31232;
      text-decoration: underline;
    }
  }
}

@media (max-width: 375px) {
  .change-password-container {
    width: 90%;
    padding: 35px 20px;
  }
}
</style>
